import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "styled-components";
import { SiteLogoImage } from "components/Site/SiteImages";
import {
  defaultSite,
  useSiteConfig
} from "components/Site/Contexts/SiteConfig";

import { SiteLinks } from "../SiteLinks";
import {
  StyledHeaderContainer,
  LogoContainer,
  StyledHeader,
  TitleContainer,
  IconContainer,
  Title
} from "./styles";

const Header: React.FC<{ hasParallels: boolean }> = ({ hasParallels }) => {
  const theme = useContext(ThemeContext);
  const site = useSiteConfig();
  const isDefaultLogo = site.logoImage.includes(defaultSite.logoImage);

  return (
    <StyledHeaderContainer>
      <StyledHeader hasParallels={hasParallels}>
        <TitleContainer>
          <Link to="/">
            <LogoContainer>
              <SiteLogoImage className={isDefaultLogo ? "default-logo" : ""} />
            </LogoContainer>
          </Link>
          {isDefaultLogo && (
            <Title key="title">
              <Link to="/">{theme.title}</Link>
            </Title>
          )}
          <IconContainer>
            <SiteLinks site={site} theme={theme} />
          </IconContainer>
        </TitleContainer>
      </StyledHeader>
    </StyledHeaderContainer>
  );
};

export default Header;
